export function jsonpRequest(url) {
  return new Promise((resolve, reject) => {
    window.jsonCallBack = (result) => {
      resolve(result);
    };

    const JSONP = document.createElement('script');

    JSONP.type = 'text/javascript';

    JSONP.src = url;

    document.getElementsByTagName('head')[0].appendChild(JSONP);

    setTimeout(() => {
      document.getElementsByTagName('head')[0].removeChild(JSONP);
    }, 500);
  });
}

// 异步加载腾讯地图API
export function loadMP(mapId, location) {
  const tmp = new Promise((resolve, reject) => {
    const hasLoaded1 = document.getElementById('tmap');
    console.log(hasLoaded1, '拿到了标签==-==');
    if (hasLoaded1) { // 只加载一次
      hasLoaded1.remove();
      // return;
    }
    window.initMap = function() {
      console.log(mapId, TMap, '初始化-----');
      const map = new TMap.Map(mapId, {
        zoom: 18.2, // 设置地图缩放级别
        // pitch: 43.5, // 设置俯仰角
        center: new TMap.LatLng(location.lat, location.lng)
      });
      const geocoder = new TMap.service.Geocoder(); // 新建一个正逆地址解析类
      // 新建一个地点搜索类
      const markers = new TMap.MultiMarker({
        map: map,
        geometries: []
      });

      resolve({ map, TMap, geocoder, markers });
    };
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://map.qq.com/api/gljs?v=1.exp&libraries=service&key=INTBZ-D35KD-6E44X-P3UMA-BWQGF-QOBOZ&callback=initMap';
    script.id = 'tmap';
    script.onerror = reject;
    document.head.appendChild(script);
  });
  return tmp;
}
